import { render } from "./SEO.vue?vue&type=template&id=01932f38&scoped=true"
import script from "./SEO.vue?vue&type=script&lang=js"
export * from "./SEO.vue?vue&type=script&lang=js"

import "./SEO.vue?vue&type=style&index=0&id=01932f38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01932f38"]])

export default __exports__